export const DOT_CIRCLE_SIZE = 5;

export const INIT_DOT_STATE = {
  initX: DOT_CIRCLE_SIZE / 2,
  initY: DOT_CIRCLE_SIZE / 2
};
